import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    component: () => import('../components/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '统计看板' }
      },
      {
        path: 'academic-year',
        name: 'AcademicYear',
        component: () => import('../views/AcademicYear.vue'),
        meta: { title: '学年管理' }
      },
      {
        path: 'class',
        name: 'ClassInfo',
        component: () => import('../views/ClassInfo.vue'),
        meta: { title: '班级管理' }
      },
      {
        path: 'student',
        name: 'Student',
        component: () => import('../views/StudentView.vue'),
        meta: { title: '学生管理' }
      },
      {
        path: 'subject',
        name: 'Subject',
        component: () => import('../views/SubjectView.vue'),
        meta: { title: '科目管理' }
      },
      {
        path: 'exam',
        name: 'Exam',
        component: () => import('../views/ExamView.vue'),
        meta: { title: '考试管理' }
      },
      {
        path: 'score',
        name: 'Score',
        component: () => import('../views/ScoreView.vue'),
        meta: { title: '成绩录入' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    if (store.state.token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
